/*
 * @Author: caiqin.xie
 * @since: 2023-06-28 17:12:46
 * @lastTime: 2023-08-11 14:40:37
 * @LastEditors: caiqin.xie
 * @message: 
 */
import React from "react";
import routes from './routes'
import { matchPath } from 'react-router-dom';
import { i18n, i18nLocal } from "./conf";

interface PageTemplateProps {
  [key:string]: any,
  staticContext?: object,
  children?: JSX.Element
}

export default class PageTemplate extends React.Component<any, any> {

  state:PageTemplateProps = {};

  constructor(props:PageTemplateProps) {
    super(props)
    if (props.staticContext) {
      console.log('server render')
      this.state = {data: props.staticContext}
    } else {
      const _Window = window as any
      if (_Window.__initData__) {
        console.log('client render raised by SSR')
        this.state = {data: _Window.__initData__}
        delete _Window.__initData__
      } else {
        console.log('client render')
        const ctry = location.pathname.split('/')[1] || 'cn'
        const currentRoute:PageTemplateProps = routes.find((route) => matchPath(location.pathname, route)) || {}
        const component = currentRoute.component || {}
        const promise = component.getInitialProps ? component.getInitialProps(ctry, location.pathname + location.search) : Promise.resolve(null)
        // @ts-ignore
        let wordsObj = {ctry, words: i18n[i18nLocal[ctry]]}
        promise.then((data: any) => {
          let _data = {data, ...wordsObj}
          this.setState({data: _data})
        }).catch((err: any) => {
          console.log(err)
          let _data = {...wordsObj}
          this.setState({data: _data})
        })
      }
    }
  }

  render() {
    if (this.state.data) {
      return React.Children.map(this.props.children, (child:JSX.Element) => {
        return React.cloneElement(child, {data: this.state.data})
      })
    } else {
      return <></>
    }
  }
}